import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class TermsConditionStore {

}

export enum TermsConditionStoreKeys {

}
